<template>
  <div>
    <v-app-bar color="primary"
               dark
               flat
               :dense="$vuetify.breakpoint.mobile"
               :max-height="$vuetify.breakpoint.mobile ? 48 : 64"
    >
      <v-btn
          v-if="isBackSupport"
          icon
          class="ml-0 mr-2"
          :small="$vuetify.breakpoint.mobile"
          @click="toBackState"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-avatar
          class="d-block d-sm-none"
          size="40"
          :tile="true"
      >
        <img
            src="assets/images/logo.png"
        />
      </v-avatar>

      <v-toolbar-title
          class="d-none d-sm-block pointer"
          @click="$router.push('/sources')"
      >
        СП Помощник
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
          v-if="showLoginButton"
          text
          href="/api/auth/start?redirectUri=/"
          :small="$vuetify.breakpoint.mobile"
      >
        Войти
      </v-btn>

      <EventsPreview v-if="showMenu"></EventsPreview>

      <v-btn
          v-if="showMenu && sourceId"
          class="mr-0"
          icon
          :class="{'margined-right': isVkAppMobile}"
          :small="$vuetify.breakpoint.mobile"
          @click="toProfilePage"
      >
        <v-icon>mdi-account</v-icon>
      </v-btn>

      <div
          v-if="showMenuVkAppDesktop"
          class="ml-3"
      >
        <v-btn
            v-if="showMenuSourceSettings"
            class="mr-3"
            icon
            @click="toSourceSettings"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
        <v-btn
            color="accent"
            small
            @click="toMessagePermissions">
          <v-icon left small>mdi-email-outline</v-icon>
          отключить
        </v-btn>
      </div>
    </v-app-bar>

    <v-row
        v-if="showMenuVkAppMobile"
        class="mobile-menu ma-2"
        no-gutters
    >
      <v-col
          v-if="showMenuSourceSettings"
          cols="6"
          class="px-1"
      >
        <v-btn
            class="full-width"
            @click="toSourceSettings"
        >
          <v-icon left>mdi-cog</v-icon>
          настройка
        </v-btn>
      </v-col>
      <v-col
          class="px-1"
          :cols="showMenuSourceSettings ? 6 : 12"
      >
        <v-btn v-if="isVkAppMobile"
               class="full-width"
               color="accent"
               @click="toMessagePermissions">
          <v-icon left>mdi-email-outline</v-icon>
          отключить <span v-if="!showMenuSourceSettings">оповещения</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EventsPreview from '@/components/EventsPreview'
import {getInVk, getShowLoginButton, getIsVkAppAdmin, getIsVkAppDesktop, getIsVkAppMobile, getSourceId}
  from '@/composables/context'
import {getUser} from '@/composables/user'
import {appStates} from '@/constants'
import {isBackSupport, toBackState} from '@/services/stateManager'

export default {
  name: 'Header',
  components: {EventsPreview},
  computed: {
    showLB: getShowLoginButton,
    isBackSupport () {
      return isBackSupport(this.showMenu, this.$route.name)
    },
    isVkAppMobile: getIsVkAppMobile,
    showLoginButton () {
      return this.showLB && this.user.unauthorized && this.$route.name !== appStates.acquiringPaymentResult.name
    },
    showMenuVkAppDesktop () {
      return this.showMenu && this.user.authorized && getIsVkAppDesktop()
    },
    showMenuVkAppMobile () {
      return this.showMenu && this.user.authorized && getIsVkAppMobile()
    },
    showMenuSourceSettings () {
      return getInVk() && this.sourceId && this.sourceId < 0 && (this.user.admin || getIsVkAppAdmin())
    },
    sourceId: getSourceId,
    user: getUser
  },
  methods: {
    toBackState () {
      const backState = toBackState(this.$route.name, {
        sourceId: this.sourceId,
        buyoutId: this.$route.params.buyoutId
      })
      if (backState) {
        this.$router.push(backState)
      } else {
        this.$router.go(-1)
      }
    },
    toMessagePermissions(){
      this.$router.push({
        name: appStates.messagePermissions.name,
        query: {sourceId: getSourceId()}
      })
    },
    toProfilePage () {
      this.$router.push({
        name: appStates.sourceItemUserProfile.name,
        params: {sourceId: this.sourceId}
      })
    },
    toSourceSettings () {
      this.$router.push({
        name: appStates.sourceItemSettings.name,
        params: {sourceId: this.sourceId}
      })
    }
  },
  props: {
    showMenu: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style scoped>
.margined-right {
  margin-right: 90px!important;
}
.pointer {
  cursor: pointer;
}
</style>
